import type { EvaluationType } from '@atlas/shared';

const LABELS: Record<EvaluationType, { full: string; short: string; noun: string }> = {
  hardware: { full: 'Hardware Evaluation', short: 'Evaluation', noun: 'evaluation' },
  software: { full: 'Software Evaluation', short: 'Software Eval', noun: 'evaluation' },
  proposal: { full: 'Product Proposal', short: 'Proposal', noun: 'proposal' },
};

/** Full display label, e.g. "Hardware Evaluation", "Product Proposal" */
export function getEvaluationTypeLabel(type: EvaluationType): string {
  return LABELS[type]?.full ?? 'Evaluation';
}

/** Short label for buttons/chips, e.g. "Evaluation", "Proposal" */
export function getEvaluationTypeShortLabel(type: EvaluationType): string {
  return LABELS[type]?.short ?? 'Evaluation';
}

/** Lowercase noun for sentences, e.g. "evaluation", "proposal" */
export function getEvaluationTypeNoun(type: EvaluationType): string {
  return LABELS[type]?.noun ?? 'evaluation';
}
